<script> 
import formtextarea from "@/router/views/FormComponet/formtextarea.vue";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import forminput from "@/router/views/FormComponet/forminput.vue";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiFilter.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrIsoDuzelticiFaaliyet from "@/models/StrIsoDuzelticiFaaliyet";
import moment from "moment"; 
export default {
  mixins: [Api, Sabit, StrIsoDuzelticiFaaliyet],
  props: ["Id", "AddEdit", "OPersonelid"],
  data() {
    return {
      FormData: {},
      MailButton: false
    };
  },
  components: {
    Loader,
    formtextarea,  BirimSecimi, formcombobox, forminput
  },
  watch: {
    Id() {
      this.FormData = this.Id;
        if(this.AddEdit == "Add"){
            this.DFNoGetir()
            this.FormData.Acanid = this.OPersonelid
        }
    },
  },
  methods: {
    async onSubmit() {
      this.$v.FormData.$touch();
      if (!this.$v.FormData.$invalid) { 
       this.FormData.Kanit = JSON.stringify( this.FormData.Kanit)
        if (this.AddEdit == "Add") {
          this.FormData.Acilistarih = moment(new Date()).format("YYYY-MM-DD");
          var res = await this.Post("StrIsoDuzelticiFaaliyet", this.FormData) 
            if (res) {
              this.FormData = this.StrIsoDuzelticiFaaliyetData
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrIsoDuzelticiFaaliyet");
            }
        
        } else {
          var res2 = await this.Update("StrIsoDuzelticiFaaliyet", this.FormData) 
            if (res2) {
              this.$emit("Update", this.FormData);
              this.FormData = this.StrIsoDuzelticiFaaliyetData
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrIsoDuzelticiFaaliyet");
            }
          
        }
        
       this.FormData.Kanit = JSON.parse( this.FormData.Kanit)
      }
    },
    DFNoGetir(){
      
      let Page= {
        PageNumber: "1",
        PageSize: "1"
      }
      this.ActionsFilterGet({ Service: "StrIsoDuzelticiFaaliyet", Page: Page, Filter: "&Desc=No" }).then((res) => {
        if(Object.keys(res.Data).length > 0){
          this.FormData.No = parseInt(res.Data[0].No) + parseInt(1)
        }
        else{
          this.FormData.No = 1
        }
      });
    },
    Get() { },
    
    async HatirlatmaMailiGonder(){

      if(this.FormData.Not ){ 
        this.MailButton = true
          for (let index = 0; index < this.FormDataType.Acanbirimid.ComboDataArray.length; index++) {
            const element = this.FormDataType.Acanbirimid.ComboDataArray[index];
                if(element.Striyilestirmemail.length > 0){
                          await this.Post("StrIyilestirmeBirim/MailGonderim", 
                            {
                              To: element.Striyilestirmemail,
                              Body: this.FormData.Not
                            }, false
                          ) 
                }
            
          } 
          
                this.$toast.info("Mail Gönderme Tamamlandı.");
        this.MailButton = false
      }
      else{
         this.$toast.error("Alanları Doldurun");
      }

    },
  },
};
</script>
<template>
  <Loader>
    <b-modal id="StrIsoDuzelticiFaaliyet" size="lg" :title="this.AddEdit == 'Edit'
        ? 'Kaydı Düzenle'
        : 'Kayıt Ekle'
      " title-class="font-18" hide-footer>
      <Form @submit.prevent="onSubmit">
        <div class="row">  

          <forminput class="col-md-6" :FormDataType="FormDataType.No" :Value="FormData.No" :v="$v.FormData.No"
            @input="FormData.No = $event" />

          <BirimSecimi class="mb-3 col-md-6" :title="FormDataType.Acanbirimid.FieldTitle" :sutun="'0'"
            :title_position="'mb-3'" :selected="FormData.Acanbirimid" :labels_lg="'3'" :v="$v.FormData.Acanbirimid"
            :multiple="false" :BirimTipId="null" @Secilmis_Idler="FormData.Acanbirimid = $event" />


          <formcombobox class="col-md-6" :FormDataType="FormDataType.Tespitsekliid" :Value="FormData.Tespitsekliid"
            :v="$v.FormData.Tespitsekliid" @input="FormData.Tespitsekliid = $event" />



          <formtextarea class="col-md-6" :FormDataType="FormDataType.Uyumsuzluktanim" :Value="FormData.Uyumsuzluktanim"
            :v="$v.FormData.Uyumsuzluktanim" @input="FormData.Uyumsuzluktanim = $event" />

          <formtextarea class="col-md-6" :FormDataType="FormDataType.Not" :Value="FormData.Not"
            :v="$v.FormData.Not" @input="FormData.Not = $event" />

  

        </div>
        <button class="btn btn-primary" type="submit">
          Kaydet ve Onayla 
        </button>
        <button class="btn btn-success" type="button" @click="HatirlatmaMailiGonder"  :disabled="MailButton">
          Tüm Birimlere Notu Gönder
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
